import React from 'react'

interface CheckboxProps {
    selectedTypeOfUpdate: string;
    setSelectedTypeOfUpdate: (value: string) => void
    status: string
}

export default function Checkbox({ selectedTypeOfUpdate, setSelectedTypeOfUpdate, status }: CheckboxProps) {
    
    const options = ["Cancelled", "Pending", "Brewing", "Claimed", "For Pick-Up"];

    const getNextStatusOptions = (status: string): string[] => {
        switch (status) {
            case "Pending":
                return options.filter(
                    (opt) => opt === "Cancelled" || opt === "Brewing"
                );

            case "Brewing":
                return options.filter(
                    (opt) => opt === "For Pick-Up"
                );

            case "For Pick-Up":
                return options.filter(
                    (opt) => opt === "Claimed"
                );

            default:
                return [];
        }
    };

    const filteredOptions = getNextStatusOptions(status);

    return (
        <>
            {filteredOptions.map((checkBox, i) => (
                <button
                    key={i}
                    onClick={() => setSelectedTypeOfUpdate(checkBox)}
                    className={`
                        flex w-full items-center justify-center text-center p-2 rounded border 
                        ${selectedTypeOfUpdate === checkBox 
                            ? 'bg-cbColor text-white' 
                            : 'border-gray-300 text-gray-700'}
                        transition-colors duration-200
                    `}
                >
                    <label className="flex w-full items-center cursor-pointer">
                        <span 
                            className={`text-sm text-center w-full`}
                        >
                            {checkBox}
                        </span>
                    </label>
                </button>
            ))}
        </>
    )
}
